module.exports = "https://coursera_assets.s3.amazonaws.com/images/eaa26023fc984840fae910176882ac3d.png";